import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import type { BreadcrumbItem } from './types';
import { getBreadcrumbLabel, getBreadcrumbPath } from './utils';

interface BreadcrumbsProps {
  items?: BreadcrumbItem[];
  customLabels?: Record<string, string>;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, customLabels }) => {
  const location = useLocation();
  const pathNames = location.pathname.split('/').filter(Boolean);

  const defaultItems = pathNames.map((value, index) => ({
    label: getBreadcrumbLabel(value, pathNames, index, customLabels),
    path: getBreadcrumbPath(pathNames, index),
  }));

  const breadcrumbItems = (items || defaultItems).filter(
    (item) => item.label && item.label.trim() !== '',
  );

  return (
    <CBreadcrumb className="my-0">
      <CBreadcrumbItem>
        <Link to="/">Home</Link>
      </CBreadcrumbItem>
      {breadcrumbItems.map((item, index) => (
        <CBreadcrumbItem
          key={item.path ?? item.label}
          active={index === breadcrumbItems.length - 1}
        >
          {item.path && index !== breadcrumbItems.length - 1 ? (
            <Link to={item.path}>{item.label}</Link>
          ) : (
            item.label
          )}
        </CBreadcrumbItem>
      ))}
    </CBreadcrumb>
  );
};
